import { useEffect, useState } from 'react';

import { saleorAuthClient } from '@/graphql/client';
import { captureError } from '@/lib/errors';
import { paths } from '@/lib/paths';

type LocationStock = {
  location: string;
  stock_display: number;
};

type ResponseData = {
  locations?: LocationStock[];
  productRef: number;
};

const fetchProductBoutiqueStocks = async (
  country: string,
  sku: string,
  authClient = saleorAuthClient,
) => {
  const response = await authClient.fetchWithAuth(
    `${paths.api.stock.productStock}?country=${country}&sku=${sku}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      cache: 'no-store',
    },
    { allowPassingTokenToThirdPartyDomains: true },
  );

  const responseJson = await response.json();
  return {
    data: responseJson as ResponseData,
  };
};

export const useBoutiqueStock = (country: string, sku: string) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [stocks, setStocks] = useState<LocationStock[]>([]);

  useEffect(() => {
    setLoading(true);
    fetchProductBoutiqueStocks(country, sku)
      .then((response) => {
        if (response?.data) {
          setStocks(response?.data?.locations ?? []);
        }
      })
      .catch((e) => {
        captureError(e as Error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return {
    loading,
    stocks,
  };
};
